<template>
  <div id="auto-anual-rules">
    <div class="flex flex-row items-center justify-between mb-6">
      <h3>Regras</h3>
      <vs-button
        radius
        v-tooltip="'Histórico de Alterações'"
        color="#88abc2"
        icon-pack="feather"
        icon="icon-archive"
        class="d-inline"
        data-testid="rules-history-button"
        @click="isHistoryModalOpen = true"
      ></vs-button>
    </div>

    <vs-row class="mb-6">
      <vs-col vs-w="6">
        <label class="vs-select--label">Soma máxima do LMI dos RCFs</label>
        <money
          v-model="formData.coverageMaxRcf"
          class="w-full vs-inputx vs-input--input normal"
          name="coverageMaxRcf"
          id="coverageMaxRcf"
          v-bind="money"
          :disabled="!canWrite"
          data-testid="rules-coverage-max-rcf"
          @input.native="handleMoneyInput"
        ></money>
        <span v-if="errors.coverageMaxRcf" class="text-danger">{{
          errors.coverageMaxRcf
        }}</span>
      </vs-col>
    </vs-row>

    <vs-row class="mb-6">
      <vs-col vs-w="6">
        <label class="vs-select--label">Estados de pernoite aceitos</label>
        <v-select
          v-model="formData.statesAllowed"
          :options="estadosOptions"
          multiple
          label="label"
          :reduce="(option) => option.id"
          placeholder="Selecione os estados aceitos"
          :disabled="!canWrite"
          data-testId="rules-states-allowed"
        />
        <span v-if="errors.statesAllowed" class="text-danger">{{
          errors.statesAllowed
        }}</span>
      </vs-col>
    </vs-row>

    <div v-if="canWrite" class="vx-row">
      <div class="vx-col w-full text-right mt-5 mb-6">
        <BotaoSubmit
          variant="success"
          :edit="true"
          :aguarde="isSubmitting"
          @submit="handleSubmit"
        ></BotaoSubmit>
      </div>
    </div>

    <AutoAnualRulesHistoryModal
      :isOpen="isHistoryModalOpen"
      @close="isHistoryModalOpen = false"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Money } from 'v-money';
import autoApi from '../../../../services/auto.api';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import AutoAnualRulesHistoryModal from './components/AutoAnualRulesHistoryModal.vue';
import BotaoSubmit from '../../../../components/BotaoSubmit.vue';

export default {
  name: 'AutoAnualRules',
  components: { vSelect, Money, AutoAnualRulesHistoryModal, BotaoSubmit },
  props: ['subjectPermission'],
  data() {
    return {
      formData: {
        coverageMaxRcf: 0,
        statesAllowed: [],
      },
      errors: {
        coverageMaxRcf: '',
        statesAllowed: '',
      },
      estadosOptions: [],
      isHistoryModalOpen: false,
      isSubmitting: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
    };
  },
  computed: {
    canWrite() {
      return this.$can(this.$actionsDefault.Escrita, this.subjectPermission);
    },
  },
  async created() {
    await Promise.all([this.loadRules(), this.loadEstadosOptions()]);
  },
  methods: {
    async loadRules() {
      try {
        const rules = await autoApi.getCompanyRules();
        this.formData.coverageMaxRcf = rules.coverageMaxRcf;
        this.formData.statesAllowed = rules.statesAllowed;
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar as regras de auto anual',
        );
      }
    },
    async loadEstadosOptions() {
      await functions.buscaDadosSelects(
        'domUf',
        this.estadosOptions,
        'nomeUf',
        'nomeUf',
      );
    },
    handleMoneyInput(event) {
      const rawValue = event.target.value.replace(/[^\d,]/g, '');
      const normalized = rawValue.replace(',', '.');
      const parsed = parseFloat(normalized);
      this.formData.coverageMaxRcf = isNaN(parsed) ? 0 : parsed;
    },
    validate() {
      this.errors.coverageMaxRcf = '';
      this.errors.statesAllowed = '';

      if (!this.formData.coverageMaxRcf || this.formData.coverageMaxRcf <= 0) {
        this.errors.coverageMaxRcf =
          'Informe um valor maior que R$ 0,00.';
      }

      if (
        !Array.isArray(this.formData.statesAllowed) ||
        this.formData.statesAllowed.length === 0
      ) {
        this.errors.statesAllowed = 'Selecione ao menos um estado.';
      }

      return !this.errors.coverageMaxRcf && !this.errors.statesAllowed;
    },
    async handleSubmit() {
      if (!this.validate()) {
        return;
      }

      this.isSubmitting = true;
      try {
        const updated = await autoApi.updateCompanyRules({
          coverageMaxRcf: this.formData.coverageMaxRcf,
          statesAllowed: this.formData.statesAllowed,
        });
        this.formData.coverageMaxRcf = updated.coverageMaxRcf;
        this.formData.statesAllowed = updated.statesAllowed;
        notify.notifySuccess(
          this.$vs,
          'Regras do auto anual atualizadas com sucesso',
        );
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Erro ao atualizar as regras do auto anual. Tente novamente',
        );
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
